export enum ENDPOINT {
  JOB_ORDERS = "job-orders",
  JOB_ORDER = "job-order",
  MACHINES = "machines",
  TOOLS = "tools",
  TECHNICIANS = "technicians",
  CERTIFICATIONS = "certifications",
  COMPONENTS = "components",
  AI_SUGGESTION = "ai-suggestion",
  WORKSPACES = "workspaces",
  WORKSPACE = "workspace",
  AI_CONFIGURATION = "ai-configuration",
  DYNAMIC_TABLE = "dynamic-table",
  EDITABLE_COLUMNS = "editable-columns",

  // ===== PLANT 3 ENDPOINTS =====
  JOB_ORDERS_DYNAMIC = "job-orders/dynamic",
  JOB_ORDERS_RANKS = "job-orders/ranks",
  PROCESSES = "processes",
  CUSTOMERS = "customers",
  PARTS = "parts",
  PROCESS = "process",
  PART_PROCESSES = "part-processes",
  PART_PROCESS = "part-process",
  PROCESS_FIELD_METADATA = "process/field-metadata",
  PART_PROCESS_FIELD_METADATA = "part-process/field-metadata",
  SHOPS = "shops",
  JOB_ORDER_WORKFLOW = "job-order-workflow",
  TEMPLATE_BY_MASTER = "template-by-master",
  TEMPLATE_BY_WORKCHESTRA = "template-by-workchestra",

  // ===== JOB SCHEDULE ENDPOINTS =====
  JOB_SCHEDULE_JOBS = "job-schedule/jobs",
  JOB_SCHEDULE_JOBS_PLANNING = "job-schedule/jobs/planning",
  JOB_SCHEDULE_JOBS_PLANNING_ASK_AI = "job-schedule/jobs/planning/ask-ai",
  JOB_SCHEDULE_TECHNICIANS = "job-schedule/technicians",
  JOB_SCHEDULE_MACHINES = "job-schedule/machines",
  AI_RECOMMENDATION_SCHEDULES = "ai-recommendation/schedules",
}
